import React from 'react';
import { connect } from 'react-redux';

import Modal from '@material-ui/core/Modal';
import LinearProgress from '@material-ui/core/LinearProgress';

import Theme from './Theme';

class LoadingModal extends React.Component {
	render() {
		return (
			<Modal open={this.props.loading}>
				<div style={{marginTop: Theme.spacing.unit * 8}}>
					<LinearProgress color="primary" />
				</div>
			</Modal>
		);
	}
}

function mapStateToProps(state) {
	const { loading } = state.loading;
	return { loading };
}

export default connect(mapStateToProps)(LoadingModal);



// WEBPACK FOOTER //
// ./src/components/LoadingModal.js